var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-date-picker',_vm._b({staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.placehold || _vm.$t('选择时间'),"disabled":_vm.disabled,"disabledDate":_vm.disabledDate,"value":_vm.value},on:{"change":_vm.onChange}},'a-date-picker',_vm.propsValue,false))
}
var staticRenderFns = []

export { render, staticRenderFns }